// extracted by mini-css-extract-plugin
export default {"container":"style_container__QlK1e","ordersList":"style_ordersList__YYc7X"};